import update from 'immutability-helper';
import typeToReducer from 'type-to-reducer';
import { applicationInitialState } from './initialState';

export default typeToReducer({
    START_LOADING_APPLICATION: (state, action) => update(state, {
        isLoadingApplication: { $set: true },
    }),
    STOP_LOADING_APPLICATION: (state, action) => update(state, {
        isLoadingApplication: { $set: false },
    }),
}, applicationInitialState);
